export const getTargetImpressions = (
  targetImpressions: any,
  paidImpressions: any,
  freeImpressions: any,
  showFirstToggled: any
) => {
  if (showFirstToggled) {
    return null;
  }

  if (paidImpressions || freeImpressions) {
    return freeImpressions + paidImpressions;
  }

  return targetImpressions;
};
